/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import { data } from './SampleCSVData';

export const page: {
  root: Item<'Page'>;
  button: Item<'Button'>;
  dataGrid: Item<'DataGrid'>;
  flexItem: Item<'FlexItem'>;
  rowPanel: Item<'RowPanel'>;
  flexItem1: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  dateColumn: Item<'DateColumn'>;
  columnPanel: Item<'ColumnPanel'>;
  actionCreate: Item<'ActionCreate'>;
  numberColumn: Item<'NumberColumn'>;
  stringColumn: Item<'StringColumn'>;
  checkboxColumn: Item<'CheckboxColumn'>;
  localDataStore: Item<'LocalDataStore'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  dataStoreReference: Item<'DataStoreReference'>;
  triggerOnClick1: Item<'TriggerOnClick'>;
  button1: Item<'Button'>;
  actionReset: Item<'ActionReset'>;
} = {
  actionCreate: {
    children: [],
    itemId: 'actionCreate',
    parent: 'triggerOnClick',
    props: {
      alias: 'test',
    },
    type: 'ActionCreate',
  },
  actionReset: {
    children: [],
    itemId: 'actionReset',
    parent: 'triggerOnClick1',
    props: {
      alias: 'test',
    },
    type: 'ActionReset',
  },
  button: {
    children: ['triggerOnClick'],
    itemId: 'button',
    parent: 'columnPanel',
    props: {
      startIcon: {
        iconName: 'bolt',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Invoke Action',
      },
    },
    type: 'Button',
  },
  button1: {
    children: ['triggerOnClick1'],
    itemId: 'button1',
    parent: 'columnPanel',
    props: {
      startIcon: {
        iconName: 'undo',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Reset',
      },
      color: 'inherit',
    },
    type: 'Button',
  },
  checkboxColumn: {
    children: [],
    itemId: 'checkboxColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Active' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'active',
    },
    type: 'CheckboxColumn',
  },
  columnPanel: {
    children: ['button', 'button1'],
    itemId: 'columnPanel',
    parent: 'rowPanel',
    props: {
      gap: '8px',
    },
    type: 'ColumnPanel',
  },
  dataGrid: {
    children: ['stringColumn', 'dateColumn', 'numberColumn', 'checkboxColumn'],
    itemId: 'dataGrid',
    parent: 'flexItem1',
    props: {
      expandLastColumn: false,
    },
    type: 'DataGrid',
  },
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'test',
    },
    type: 'DataStoreReference',
  },
  dateColumn: {
    children: [],
    itemId: 'dateColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Some Date' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'someDate',
      width: 150,
    },
    type: 'DateColumn',
  },
  flexItem: {
    children: ['rowPanel'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {
      padding: {
        all: 8,
      },
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['dataGrid'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem', 'flexItem1'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      data,
      dataSource: 'test',
    },
    type: 'LocalDataStore',
  },
  numberColumn: {
    children: [],
    itemId: 'numberColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Some Number' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'someNumber',
      width: 120,
    },
    type: 'NumberColumn',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  rowPanel: {
    children: ['columnPanel'],
    itemId: 'rowPanel',
    parent: 'flexItem',
    props: {},
    type: 'RowPanel',
  },
  stringColumn: {
    children: [],
    itemId: 'stringColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Name' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'name',
      width: 200,
    },
    type: 'StringColumn',
  },
  triggerOnClick: {
    children: ['actionCreate'],
    itemId: 'triggerOnClick',
    parent: 'button',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['actionReset'],
    itemId: 'triggerOnClick1',
    parent: 'button1',
    props: {},
    type: 'TriggerOnClick',
  },
};
